import { Button } from "@jhool-io/fe-components";
import { useErrorBoundary } from "react-error-boundary";

export default function AppFallback() {
    const { resetBoundary } = useErrorBoundary();

    return (
        <div className="min-h-screen flex items-center justify-center p-20">
            <div className="flex flex-col items-center justify-center text-center w-[60rem] max-w-full">
                <p className="font-semibold text-base leading-[2.2rem] uppercase text-primary mb-20">
                    Patient Portal by Mantle
                </p>
                <h3 className="text-24 font-normal mb-10">
                    Something went wrong
                </h3>
                <p className="font-semibold text-sm leading-6">
                    You just encountered an unexpected error. We have been made
                    aware of it and we will address this issue as quickly as we
                    can. Please contact support to provide more information on
                    the issue. Thank you for your understanding.
                </p>
                <Button
                    type="button"
                    size="small"
                    onClick={resetBoundary}
                    className="px-10 mt-20"
                >
                    Go back
                </Button>
            </div>
        </div>
    );
}
